<template>
  <!--Login Page-->
  <v-app>
    <v-content>
      <v-row class="fill-height">
        <v-col class="text-center align-self-center">
          <span style="text-transform: uppercase;">{{
            $t("Account Login")
          }}</span>
          <div class="errormsg" v-if="$route.query.message">
            {{ $route.query.message }}
          </div>
          <!-- <div class="usermsg" v-if="errormsg">{{ errormsg }}</div> -->
          <v-card
            class="mx-auto"
            style="background-color: #eeeeee; padding:25px; border-radius: 4px; border: 3px solid #dddddd;"
            :style="{ width: $vuetify.breakpoint.xs ? '100%' : '400px' }"
          >
            <v-row>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-col class="pl-12 ml-12">
                <router-link to="/front" style="text-decoration:none;">
                  <v-btn large icon color="error" outlined>
                    <v-icon large>fas fa-times</v-icon>
                  </v-btn>
                </router-link>
              </v-col>
            </v-row>
            <router-link to="/front">
              <v-img src="/wenewz_middle_2color.svg" />
            </router-link>
            <v-form @submit.prevent="submitLogin" class="pt-5">
              <v-text-field
                :label="$t('Email')"
                v-model="username"
                required
                :rules="[(v) => !!v || this.$t('Email Required')]"
              ></v-text-field>
              <v-text-field
                :label="$t('Password')"
                v-model="password"
                type="password"
                required
                :rules="[(v) => !!v || this.$t('Password are Required')]"
              ></v-text-field>
              <v-btn block type="submit" class="mt-5">{{ $t("Login") }}</v-btn>
            </v-form>
            <v-divider></v-divider>
            <div class="body-1 pt-2">
              <span>{{ $t("If have forgotten your password") }} </span>
              <br />
              <span>
                <router-link :to="'/forgotpassword?user=' + username">{{
                  $t("Click here")
                }}</router-link
                >!
              </span>
            </div>
            <div class="body-1 pt-2">
              <span>{{ $t("If you dont have an user") }} </span>
              <br />
              <span>
                <router-link to="/register">{{ $t("Click here") }}</router-link
                >!
              </span>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-content>
  </v-app>
</template>

<script>
import messages from "./modules/lang/export";
export default {
  i18n: { messages },
  data() {
    return {
      username: "",
      password: "",
      errormsg: "",
      successmsg: "",
      errormsgtimer: null,
      successmsgtimer: null,
      forgotpassword: true,
    };
  },
  watch: {
    errormsg() {
      clearTimeout(this.errormsgtimer);
      if (this.errormsg != "") {
        alert(this.errormsg);
        this.errormsgtimer = setTimeout(() => {
          this.errormsg = "";
        }, 3000);
      }
    },
    successmsg() {
      clearTimeout(this.successmsgtimer);
      if (this.successmsg != "") {
        this.successmsgtimer = setTimeout(() => {
          this.successmsg = "";
        }, 3000);
      }
    },
  },
  methods: {
    submitLogin() {
      let _userobj = { username: this.username, password: this.password };
      this.$store
        .dispatch("login", _userobj)
        .then((resp) => {
          this.successmsg = resp;
          setTimeout(() => {
            if (this.$route.query && this.$route.query.redirectFrom) {
              this.$router.push({ path: this.$route.query.redirectFrom });
            } else {
              this.$router.push({ name: "frontpage" });
            }
          }, 600);
        })
        .catch((err) => {
          console.error(err);
          this.errormsg = err;
        });
    },
  },
};
</script>

<style scoped>
.errormsg {
  position: absolute;
  top: 0;
  width: 100;
  left: 0;
  right: 0;
  text-align: center;
  background-color: #cc0000;
  color: white;
  border-bottom: 2px solid red;
}
</style>
